import type React from 'react';
import { Box, ButtonIcon, IconArrow, IconChevron } from 'braid-design-system';

const directionLabel = {
  left: 'Prev',
  right: 'Next',
};

interface NavButtonProps {
  direction: 'left' | 'right';
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled: boolean;
  icon?: 'IconChevron' | 'IconArrow';
}
export const NavButton = ({
  direction,
  onClick,
  disabled,
  icon = 'IconChevron',
}: NavButtonProps) => {
  const Icon = icon === 'IconChevron' ? IconChevron : IconArrow;
  if (disabled) {
    return null;
  }
  return (
    <Box
      data={{
        testid: `carousel-nav-${directionLabel[direction].toLowerCase()}`,
      }}
      borderRadius="full"
      padding="xsmall"
      marginRight={direction === 'left' ? 'small' : 'none'}
      marginLeft={direction === 'right' ? 'small' : 'none'}
      background="surface"
      boxShadow="borderNeutralLight"
      style={{ opacity: disabled ? '0.3' : '1' }}
    >
      <ButtonIcon
        id={`carousel-${directionLabel[direction]}`}
        icon={<Icon tone="neutral" direction={direction} />}
        size="large"
        label={directionLabel[direction]}
        variant="transparent"
        bleed={true}
        onClick={onClick}
      />
    </Box>
  );
};
